import { useState } from 'react'
import { saveContent } from '@/integrations/supabase/client'
import { DEFAULT_TEXTS } from '@/lib/index'

interface Props {
  id: string
  editMode: boolean
  remoteContent: Record<string, string>
  tag?: keyof JSX.IntrinsicElements
  className?: string
  multiline?: boolean
}

export function EditableText({ id, editMode, remoteContent, tag: Tag = 'span', className = '', multiline = false }: Props) {
  // Priorité : valeur Supabase > valeur par défaut
  const resolved = remoteContent[id] ?? DEFAULT_TEXTS[id] ?? id
  const [localText, setLocalText] = useState(resolved)

  // Si le contenu distant change (après chargement), mettre à jour
  const displayText = editMode ? localText : (remoteContent[id] ?? DEFAULT_TEXTS[id] ?? id)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleBlur(e: any) {
    const val: string = e.currentTarget?.innerText ?? ''
    setLocalText(val)
    // Sauvegarder sur Supabase → visible par tous immédiatement
    saveContent(id, val)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleKeyDown(e: any) {
    if (!multiline && e.key === 'Enter') { e.preventDefault(); e.currentTarget?.blur() }
  }

  if (!editMode) return <Tag className={className}>{displayText}</Tag>

  return (
    <Tag
      className={`${className} outline-none ring-1 ring-primary/50 rounded px-0.5 cursor-text whitespace-pre-wrap`}
      contentEditable suppressContentEditableWarning
      onBlur={handleBlur} onKeyDown={handleKeyDown}
      dangerouslySetInnerHTML={{ __html: localText }}
    />
  )
}
